import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserApi } from "../../app/api/user.api";
import "./ActivateAccount.css";


export function ActivateAccount() 
{
  const navigate = useNavigate();
  const user = useMemo(() => UserApi(), []);
  const { token } = useParams();
  
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {

    const validateAccount = async () => {
      try {

        const { data } = await user.activateAccount({ activationToken: token });

        if (data.success) {
          setStatus("success");
          setMessage( "Compte activé avec succès !");
          setLoading(false);

          // Redirection après 5 secondes
          setTimeout(() => navigate("/") , 5000);

        } else {
          setStatus("error");
          setMessage( "Erreur lors de l'activation");
          setLoading(false);
        }

      } catch (err) {
        console.error("Erreur d'activation:", err);
        setStatus("error");
        const response = err?.response?.data;
        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].msg || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }
      }
      finally{
        setLoading(false);
      }
      
    };

    validateAccount();
  }, [token, navigate, user]);

  return (
    <div className="login-container">
      <div className="activate-card border">
        {
         loading && (
          <div className="d-flex flex-column align-items-center gap-3">
            <div className="spinner-border text-green mb-3" style={{ width: '5rem', height: '5rem' }}></div>
            <p className="text-secondary">Activation de votre compte en cours...</p>
          </div>
        )}

        {!loading && status === "success" && (
          <div className="success-section">
            <div className="success-icon">
              <i className="bi bi-check-circle text-green"></i>
            </div>
            <h2 className="text-secondary">Succès !</h2>
            <p className="status-message">{message}</p>
            <p className="redirect-text">Redirection vers l'accueil dans 5 secondes...</p>
          </div>
        )}

        {!loading && status === "error" && (
          <div className="error-section">
            <div className="error-icon">
              <i className="bi bi-exclamation-circle"></i>
            </div>
            <h2>Erreur d'activation</h2>
            <p className="status-message">{message}</p>
            <button onClick={() => navigate("/connexion")} className="btn btn-sm btn-outline-green mt-3" >
              Retour à la connexion <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
